<p-stepper [value]="activeIndex" class="steps-custom">
  <p-step-list>
    <p-step *ngFor="let item of items; let i = index" [value]="i" [disabled]="true">{{ item.label }}</p-step>
  </p-step-list>
</p-stepper>

